import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noAtlasProjectDisplayName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noAtlasProjectDisplayName: {
		id: 'ui.groupHeader.atlasProjectGroupHeader.noAtlasProjectDisplayName',
		defaultMessage: 'No project',
		description:
			'Text used as a group name for issues with no Atlas projects when grouping items by Atlas project is enabled.',
	},
});
export default messages;
